import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M4 12l16 0","key":"svg-1"}],["path",{"d":"M4 18l16 0","key":"svg-2"}]]

const IconMenu2 = createReactComponent('outline', 'menu-2', 'Menu2', __iconNode);

export default IconMenu2;